import { render } from "./AlignContainer.vue?vue&type=template&id=a0abffee&scoped=true"
import script from "./AlignContainer.vue?vue&type=script&lang=js"
export * from "./AlignContainer.vue?vue&type=script&lang=js"

import "./AlignContainer.vue?vue&type=style&index=0&id=a0abffee&scoped=true&lang=css"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0abffee"]])

export default __exports__